module.exports = __webpack_public_path__ + "img/check-circle.37d857b9.svg";